import * as modal from '../reducers/modalReducer';
import * as page from '../reducers/pageReducer';

const injectPopStatePlugin = (store) => {
  window.onpopstate = () => {
    const state = store.getState();
    if (document.activeElement && document.activeElement.nodeName === 'INPUT') {
      document.activeElement.blur();
      window.history.pushState(null, null, window.location.href);
    } else if (modal.isModalOpened(state)) {
      store.dispatch(modal.hideModal());
      window.history.pushState(null, null, window.location.href);
    } else if (page.isPageOpened(state)) {
      store.dispatch(page.hidePage());
      window.history.pushState(null, null, window.location.href);
    }
  };
};

export default injectPopStatePlugin;



// WEBPACK FOOTER //
// ./src/helpers/injectPopStatePlugin.js